import { IconButton } from "@mui/material";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";


export const useGetConfirmarEquipoColumns = (tiposProfesional, frecuenciasProfesional, onDeleteRow) => {

    const columns = [
        {
            field: 'action',
            headerName: '',
            align: 'center',
            renderCell: ({ row }) => {
                return (
                    <IconButton onClick={() => onDeleteRow(row.idTipoProfesional, row.idFrecuencia, row.idProfesional)}>
                        <DeleteOutlinedIcon color='action' />
                    </IconButton>
                )
            }
        },
        {
            field: 'idTipoProfesional',
            headerName: 'Tipo Profesional',
            flex: 4,
            valueGetter: (idTipoProfesional) => (tiposProfesional.find(x => x.id === idTipoProfesional)?.displayName || ''),
        },
        {
            field: 'idFrecuencia',
            headerName: 'Frecuencia',
            flex: 4,
            valueGetter: (idFrecuencia) => (frecuenciasProfesional.find(x => x.id === idFrecuencia)?.displayName || ''),
        },
        {
            field: 'nombreCompleto',
            headerName: 'Profesional',
            flex: 2,
            valueGetter: (nombreCompleto) => (nombreCompleto )
        }
    ];

    return generateColumnsDefaultConfiguration(columns);
}
